module.exports = __webpack_public_path__ + "static/media/mixed-number-fraction.9d0e2404.svg";